import { Linear, Sine, TimelineLite, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../../Data/Constants";
import * as SFX from "../../Data/SoundEffectKeys";
import { Obstacle } from "../../GameObjects/Obstacles/Obstacle";
import { BoxCollider } from "../../Physics/BoxCollider";

export class DyeBomb extends Obstacle {
    private static readonly SPEED: number = -125;
    private static readonly Y_RANGE: PIXI.Point = new PIXI.Point(-350, 100);
    private static readonly ANIM_KEY: string = "AnimKey";
    private static readonly COLOURS: number[] = [
        HLF.Colour.rgbToHex(250, 60, 40), // Red
        HLF.Colour.rgbToHex(250, 180, 50), // Orange
        HLF.Colour.rgbToHex(250, 240, 90), // Yellow
        HLF.Colour.rgbToHex(150, 210, 80), // Green
        HLF.Colour.rgbToHex(30, 170, 210), // Blue
        HLF.Colour.rgbToHex(110, 40, 130), // Indigo
        HLF.Colour.rgbToHex(250, 80, 230), // Violet
    ];

    private _burst: HLF.AnimatedSprite;

    private _rotateTween: TweenMax | undefined;
    private _alphaTween: TimelineLite | undefined;
    private _throwTween: TweenLite | undefined;

    constructor() {
        super(DyeBomb.SPEED, new BoxCollider(0, 70, -35, 35));
        this._collisionSfx = SFX.IMPACT_DYEBOMB;

        this._image = HLF.PixiUtils.makeSprite("dye-bomb", Constants.SPRITESHEET_OBSTACLE_PREFIX + "00");
        this._image.position.x = this._image.width * 0.5;
        this._image.tint = HLF.ArrayUtils.random(DyeBomb.COLOURS);
        this.addChild(this._image);

        this._burst = new HLF.AnimatedSprite();
        this._burst.tint = this._image.tint;
        this._burst.anchor.set(0.3, 0.5);
        this._burst.addAnimation(DyeBomb.ANIM_KEY, new HLF.SpriteAnimation(
            "dye-bomb-burst-", Constants.SPRITESHEET_OBSTACLE_PREFIX + "00", 7, 2,
            12, false,
        ));
        this._burst.visible = false;
        this.addChild(this._burst);

        this._rotateTween = TweenMax.to(this._image, 1.5, {
            rotation: -Math.PI * 2,
            ease: Linear.easeNone,
            repeat: -1,
        });

        this.position.y = 300;
        this._throwTween = TweenLite.to(this, 1.5, {
            y: HLF.Random.floatBetweenPoint(DyeBomb.Y_RANGE),
            ease: Sine.easeOut,
        });
    }

    public update(pDeltaTime: number): void {
        super.update(pDeltaTime);
        this._burst.update(pDeltaTime);
    }

    // public onCollision(pIsBalloonInvuln: boolean): void {
    //     super.onCollision(pIsBalloonInvuln);

    //     if (pIsBalloonInvuln) {
    //         this.playDeflectAnim();
    //     }
    //     else {
    //         this._image!.visible = false;
    //         this._burst.visible = true;
    //         this._burst.play(DyeBomb.ANIM_KEY);
    //         if (this._rotateTween !== undefined) { this._rotateTween.kill(); }

    //         this._alphaTween = new TimelineLite();
    //         this._alphaTween.to(this._burst, 0.5, {
    //             alpha: 0,
    //             ease: Sine.easeOut,
    //         }, 0.25);
    //     }
    // }

    public destroy(pOptions: boolean | PIXI.DestroyOptions = { children: true }): void {
        if (this._alphaTween !== undefined) { this._alphaTween.kill(); }
        if (this._rotateTween !== undefined) { this._rotateTween.kill(); }
        if (this._throwTween !== undefined) { this._throwTween.kill(); }
        super.destroy(pOptions);
    }
}
